import logoPNG from "../../assets/images/logo.png";
import style from "./loading.module.css";
function LoadingDefault() {
  return (
        <div className={style.loading_container}>

            <div className='d-flex flex-column align-items-center text-center'>
                <img src={logoPNG} alt="Apito" className={style.loading_size_img_logo} />
                <div className="spinner-border text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <div className={`text-light ${style.loading_fs_text}`}>
                    Aguarde enquanto<br />carregamos a página...
                </div>
            </div>
        </div>
    )
}
export {
  LoadingDefault as default
};